module.exports = __webpack_public_path__ + "img/trx.ea3ca53f.svg";